import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
  Grid
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from '@mui/icons-material/Check';

const AttendeeMatches = ({ data }) => {
  return (
    <>
      {data.map((d, i) => {
        return (
          <Accordion key={d.attendee._id}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="body1">{i +1} | {d.attendee?.user?.profile?.firstName} {d.attendee?.user?.profile?.lastName} | Matches: {d.matches.length} </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List>
                <ListItem>
                    <Grid container direction="row">
                        {/* <Grid item xs={2}><Typography variant="subtitle1" style={{fontWeight: "bold"}}>Round</Typography></Grid>
                        <Grid item xs={2}><Typography variant="subtitle1" style={{fontWeight: "bold"}}>Table</Typography></Grid> */}
                        <Grid item xs={4}><Typography variant="subtitle1" style={{fontWeight: "bold"}}>Match</Typography></Grid>
                        <Grid item xs={2}><Typography variant="subtitle1" style={{fontWeight: "bold"}}>Email Sent</Typography></Grid>
                    </Grid>
                </ListItem>
                {d.matches.map((r,i) => {
                    return (
                        <ListItem key={`${i}-${r.firstName}`}>
                            <Grid container direction="row">
                                {/* <Grid item xs={2}>{r.round}</Grid>
                                <Grid item xs={2}>{r.table}</Grid> */}
                                <Grid item xs={4}>{r.firstName} {r.lastName}</Grid>
                                <Grid item xs={2}>{r.emailSent === true ? <CheckIcon /> : <></>}</Grid>
                            </Grid>
                        </ListItem>
                    )
                })}
              </List>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};

export default AttendeeMatches;
